import { Box, Snackbar, Stack, SnackbarContent } from "@mui/material";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import { setExportedSummarySnackbarOpen } from "src/store/features/staking.slice";
import { SmallSpanRoobertNormalDark } from "./staking-styled-components";
import { useDispatch } from "react-redux";
import { useStakingState } from "src/store/features/staking.slice";

export const ExportedSummarySnackbar = () => {
  const { exportedSummarySnackbarOpen } = useStakingState();
  const dispatch = useDispatch();

  return (
    <Box sx={{ width: 500 }}>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={exportedSummarySnackbarOpen}
        onClose={() => dispatch(setExportedSummarySnackbarOpen(false))}
        key={"bottom-left"}
        autoHideDuration={2000}>
        <SnackbarContent
          elevation={0}
          message={
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <GridCheckCircleIcon sx={{ fontSize: "16px", color: "#002035" }} />
              <SmallSpanRoobertNormalDark>
                Your summary has been successfully exported!
              </SmallSpanRoobertNormalDark>
            </Stack>
          }
          sx={{
            background: "#F0FEF9",
            borderRadius: "10px",
            color: "#002035",
            boxShadow: "none",
            filter: "none",
          }}
        />
      </Snackbar>
    </Box>
  );
};
